import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function OpenAdvances() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/advances/open-report").then(r => setD(r.data)); }, []);
  return (
    <div className="p-6 lg:p-8">
      <div className="text-xs uppercase tracking-widest text-slate-500 font-medium">Reports · Ageing</div>
      <h1 className="font-display text-3xl font-extrabold mt-1 mb-4">Open advances</h1>
      {!d ? <p className="text-sm text-slate-500">Loading…</p> : (
        <Card><CardContent className="p-0 overflow-x-auto">
          <div className="p-3 text-sm">Outstanding <b>₹ {d.total_outstanding.toLocaleString()}</b> · Overdue (&gt;30 days) <b className="text-rose-700">{d.overdue_count}</b></div>
          <table className="w-full text-sm" data-testid="open-advances-table">
            <thead className="bg-slate-50 text-xs uppercase text-slate-500"><tr>{["Ref", "Requester", "Project", "Amount", "Outstanding", "Disbursed", "Age (days)", "Settlement"].map(h => <th key={h} className="text-left px-3 py-2">{h}</th>)}</tr></thead>
            <tbody>{d.rows.map(r => (
              <tr key={r.id} className={`border-b ${r.overdue ? "bg-rose-50 text-rose-800" : ""}`} data-testid={`open-adv-${r.advance_id}`}>
                <td className="px-3 py-2 font-mono">{r.advance_id}</td><td className="px-3 py-2">{r.requester_name}</td><td className="px-3 py-2">{r.project}</td>
                <td className="px-3 py-2 font-mono">₹ {(r.amount || 0).toLocaleString()}</td><td className="px-3 py-2 font-mono">₹ {(r.outstanding || 0).toLocaleString()}</td>
                <td className="px-3 py-2">{(r.disbursed_at || "").slice(0, 10)}</td><td className="px-3 py-2 font-semibold">{r.age_days ?? "—"}</td>
                <td className="px-3 py-2 text-xs">{r.pending_settlement ? "Bills in approval" : r.overdue ? "Overdue" : "Open"}</td>
              </tr>
            ))}</tbody>
          </table>
        </CardContent></Card>
      )}
    </div>
  );
}
